import { nullifyTransforms } from "./helpers"

function getScrollParent(node) {
  if (node == null) {
    return null
  }

  if (node.matches("html")) {
    return null
  }

  if (node.scrollHeight > node.clientHeight) {
    return node
  } else {
    return getScrollParent(node.parentNode)
  }
}

export const handleDragFor = (flexyInstance, getState, setState) => {
  if (!flexyInstance.options.hasDragAndDrop) {
    return
  }

  const sliderContainer = flexyInstance.sliderContainer

  const handleDown = (e) => {
    if (!getState().sliderActivated) return

    if (
      flexyInstance.options.elementsThatDoNotStartDrag.reduce(
        (shouldSkipDrag, selector) =>
          shouldSkipDrag
            ? true
            : e.target.matches(selector) || e.target.closest(selector),

        false
      )
    ) {
      return
    }

    const initialEventType = e.type

    // e.preventDefault()
    e.stopPropagation()
    if (e.type !== "touchstart") {
      e.preventDefault()
    }

    let caughtScroll = false

    if (initialEventType === "touchstart") {
      setState({
        ...getState(),
        startX: e.pageX || e.touches[0].pageX,
        endX: e.pageX || e.touches[0].pageX,
      })
    } else {
      setState({
        ...getState(),
        startX: e.pageX || e.touches[0].pageX,
        endX: e.pageX || e.touches[0].pageX,
        mouseDown: true,
        downScrollPosition: {
          x: window.pageXOffset,
          y: window.pageYOffset,
        },
        positionSnapshot: getState().positionX,
      })
    }

    const handleMouseUp = (e) => {
      if (!getState().mouseDown) return

      e.stopPropagation()

      setState({
        ...getState(),
        mouseDown: false,
      })

      document.removeEventListener("mousemove", handleMouseMove)
      document.removeEventListener("mouseup", handleMouseUp)

      document.removeEventListener("touchmove", handleMouseMove)
      document.removeEventListener("touchend", handleMouseUp)

      document.removeEventListener("scroll", handleScroll)

      if (getScrollParent(e.target)) {
        getScrollParent(e.target).removeEventListener("scroll", handleScroll)
      }

      let state = getState()

      let fromPercentage =
        (state.positionX * 100) /
        nullifyTransforms(
          sliderContainer.firstElementChild,
          flexyInstance.options.nullifyTransformEl
        ).width

      setState({
        ...getState(),
        positionTarget:
          (nullifyTransforms(
            sliderContainer.firstElementChild,
            flexyInstance.options.nullifyTransformEl
          ).width *
            (Math.abs(state.endX - state.startX) > 50
              ? state.endX - state.startX < 0
                ? Math.floor(fromPercentage / 100) * 100
                : Math.ceil(fromPercentage / 100) * 100
              : Math.round(fromPercentage / 100) * 100)) /
          100,
      })
    }

    const handleMouseMove = (e) => {
      let { pageX: endX } = e

      if (!endX) {
        endX = e.touches[0].pageX
      }

      if (caughtScroll) {
        handleMouseUp(e)
        return
      }

      if (initialEventType === "touchstart" && !getState().mouseDown) {
        if (Math.abs(endX - getState().startX) > 3) {
          flexyInstance.options.onDragStart(e)

          setState({
            ...getState(),
            startX: e.pageX || e.touches[0].pageX,
            endX: e.pageX || e.touches[0].pageX,
            mouseDown: true,
            positionSnapshot: getState().positionX,
          })

          caughtScroll = false

          document.removeEventListener("scroll", handleScroll)

          if (getScrollParent(e.target)) {
            getScrollParent(e.target).removeEventListener(
              "scroll",
              handleScroll
            )
          }
        }

        return
      }

      e.preventDefault()

      let state = getState()

      let { startX, positionSnapshot } = state

      setState({
        ...state,
        endX,
      })
    }

    const handleScroll = (e) => {
      caughtScroll = true
    }

    document.addEventListener("mousemove", handleMouseMove)
    document.addEventListener("mouseup", handleMouseUp)

    document.addEventListener("touchmove", handleMouseMove, { passive: false })
    document.addEventListener("touchend", handleMouseUp, { passive: false })

    document.addEventListener("scroll", handleScroll)

    if (getScrollParent(e.target)) {
      getScrollParent(e.target).addEventListener("scroll", handleScroll)
    }
  }

  sliderContainer.addEventListener("mousedown", handleDown, { passive: false })
  sliderContainer.addEventListener("touchstart", handleDown, { passive: false })

  if (
    flexyInstance.options.initialDragEvent &&
    !flexyInstance.options.initialDragEvent.target.closest(
      ".flexy-pills > * > *"
    )
  ) {
    requestAnimationFrame(() => {
      handleDown(flexyInstance.options.initialDragEvent)
    })
  }
}
